import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import ArticleCard from './ArticleCard';

const CAT_LABEL = {
  headlines: 'Headline News', politics: 'Politics', sport: 'Sport', financials: 'Financials', fashion: 'Fashion',
};

// A category section for the home page: title bar + lead card + list.
export default function SectionBlock({ slug, articles = [] }) {
  if (!articles.length) return null;
  const [lead, ...rest] = articles;

  return (
    <section className="fade-up">
      <div className="flex items-center justify-between border-b-2 border-[#157347] mb-4">
        <h2 className="font-display font-extrabold text-2xl text-[#0b3d26] pb-2 relative">
          <span className="bg-[#157347] text-white px-3 py-1 rounded-t-md text-lg mr-0">{CAT_LABEL[slug]}</span>
        </h2>
        <Link to={`/category/${slug}`} className="inline-flex items-center gap-1 text-sm font-semibold text-[#157347] hover:gap-1.5 transition-all pb-2">
          View all <ChevronRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <ArticleCard article={lead} variant="feature" />
        <div className="flex flex-col divide-y divide-[#eef2f0]">
          {rest.slice(0, 4).map((a) => (
            <ArticleCard key={a.id} article={a} variant="list" />
          ))}
        </div>
      </div>
    </section>
  );
}
